import React from 'react';
import { formatPropertyWithEmptyDefaultValue } from 'utils/normalizeData';
import ButtonMedium from 'components/common/Buttons/ButtonMedium';
import {
  getFileName,
  downloadCsv,
  formatCsv,
  getHeaderColumns,
  getFieldNames,
} from './utils';
import './styles.scss';

const DEFAULT_EMPTY_VALUE = '-';

export interface ICsvButtonPaginated {
  csvData: IFormattedPatientAdherenceDetails[];
  isTableLoading: boolean;
}

const CsvButtonPaginated = (props: ICsvButtonPaginated) => {
  const formattedCsvData = formatCsv(props.csvData);
  const finalData = formatPropertyWithEmptyDefaultValue(
    formattedCsvData,
    'externalRef',
    DEFAULT_EMPTY_VALUE,
  );
  const downloadData = (
    event: React.SyntheticEvent<HTMLAnchorElement, Event>,
  ) => {
    downloadCsv(
      event,
      finalData,
      getFileName(),
      getHeaderColumns(),
      getFieldNames(),
    );
  };

  return (
    <div
      data-testid="download-csv-button"
      styleName="download-csv-button"
      id="csvDownload"
    >
      <ButtonMedium
        disabled={props.isTableLoading}
        testidProp="csvDownload"
        buttonRole="primary"
        handleClick={downloadData}
        width="150px"
      >
        Export to CSV
      </ButtonMedium>
    </div>
  );
};

export default CsvButtonPaginated;
